import { render, staticRenderFns } from "./_orderform.vue?vue&type=template&id=315469a5&"
import script from "./_orderform.vue?vue&type=script&lang=ts&"
export * from "./_orderform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315469a5')) {
      api.createRecord('315469a5', component.options)
    } else {
      api.reload('315469a5', component.options)
    }
    module.hot.accept("./_orderform.vue?vue&type=template&id=315469a5&", function () {
      api.rerender('315469a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/mypages/_orderform.vue"
export default component.exports